import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {Tab} from 'devextreme-react/form';


export default class FormTab extends Component {
    render() {
        return <Tab
            {...omit(['loading_state', 'setProps', 'children'], this.props)}
        >
            {this.props.children}
        </Tab>
    }
}

FormTab.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    /**
     * Specifies whether or not labels of items displayed within the current tab are aligned
     */
    alignItemLabels: PropTypes.bool,
    /**
     * Specifies a badge text for the tab
     */
    badge: PropTypes.string,
    /**
     * The count of columns in the tab layout
     */
    colCount: PropTypes.number,
    /**
     * Specifies the relation between the screen size qualifier and the number of columns in the tabbed layout
     */
    colCountByScreen: PropTypes.object,
    /**
     * An alias for the template property specified in React. Accepts a custom component.
     */
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * Specifies whether the tab responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the icon to be displayed on the tab
     */
    icon: PropTypes.string,
    /**
     * Holds an array of form items displayed within the tab
     */
    items: PropTypes.arrayOf(PropTypes.object),
    /**
     * An alias for the template property specified in React. Accepts a rendering function.
     */
    render: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * An alias for the tabTemplate property specified in React. Accepts a custom component.
     */
    tabComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the tabTemplate property specified in React. Accepts a rendering function.
     */
    tabRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * The template to be used for rendering the tab
     */
    tabTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * The template to be used for rendering the tab content
     */
    template: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies the tab title
     */
    title: PropTypes.string,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

FormTab.defaultProps = {
    alignItemLabels: true,
    // badge: undefined,
    colCount: 1,
    // colCountByScreen: undefined,
    // component: undefined,
    disabled: false,
    // icon: undefined,
    // items: undefined,
    // render: undefined,
    // tabComponent: undefined,
    // tabRender: undefined,
    // tabTemplate: undefined,
    // template: undefined,
    // title: undefinedg,
};
